import { render, staticRenderFns } from "./ClientsEditClientTabProjects.vue?vue&type=template&id=0a699c0a"
import script from "./ClientsEditClientTabProjects.vue?vue&type=script&lang=js"
export * from "./ClientsEditClientTabProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports